export default __webpack_public_path__ + "static/media/books.8f1b14c1.jpg";